import React, { useState } from 'react';
import { CalendarIcon, FilterIcon, RefreshCwIcon } from 'lucide-react';
interface DashboardFiltersProps {
  onFilterChange: (filters: any) => void;
  onRefresh: () => void;
}
const DashboardFilters: React.FC<DashboardFiltersProps> = ({
  onFilterChange,
  onRefresh
}) => {
  const [timeFilter, setTimeFilter] = useState('Today');
  const [channel, setChannel] = useState('All Channels');
  const [scheme, setScheme] = useState('All Schemes');
  const [terminal, setTerminal] = useState('All Terminals');
  const [branch, setBranch] = useState('All Branches');
  const timeOptions = ['Today', 'Day', 'Week', 'MTD', 'YTD'];
  const handleTimeChange = (option: string) => {
    setTimeFilter(option);
    onFilterChange({
      time: option,
      channel,
      scheme,
      terminal,
      branch
    });
  };
  const handleSelectChange = (key: string, value: string) => {
    if (key === 'channel') setChannel(value);
    if (key === 'scheme') setScheme(value);
    if (key === 'terminal') setTerminal(value);
    if (key === 'branch') setBranch(value);
    onFilterChange({
      time: timeFilter,
      channel: key === 'channel' ? value : channel,
      scheme: key === 'scheme' ? value : scheme,
      terminal: key === 'terminal' ? value : terminal,
      branch: key === 'branch' ? value : branch
    });
  };
  return <div className="bg-white rounded-2xl border border-slate-200 shadow-sm px-4 py-3 mb-8 flex flex-col lg:flex-row lg:items-center justify-between gap-4" data-id="element-98">
      {/* Time Filters */}
      <div className="flex items-center space-x-1 bg-slate-50 p-1 rounded-xl border border-slate-200/60 overflow-x-auto" data-id="element-99">
        {timeOptions.map(option => <button key={option} onClick={() => handleTimeChange(option)} className={`px-4 py-1.5 text-sm font-medium rounded-lg whitespace-nowrap transition-all duration-200 ${timeFilter === option ? 'bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-md shadow-indigo-500/20' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-200/50'}`} data-id="element-100">
            {option}
          </button>)}
      </div>

      {/* Dropdown Filters */}
      <div className="flex flex-wrap items-center gap-3" data-id="element-101">
        <div className="flex items-center text-slate-400 bg-slate-50 p-2 rounded-lg border border-slate-200/60 hidden sm:flex" data-id="element-102">
          <FilterIcon className="h-4 w-4" data-id="element-103" />
        </div>

        <select value={channel} onChange={e => handleSelectChange('channel', e.target.value)} className="text-sm border border-slate-200 rounded-xl py-2 pl-3 pr-8 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 bg-white text-slate-700 hover:bg-slate-50 transition-colors cursor-pointer" data-id="element-104">
          <option data-id="element-105">All Channels</option>
          <option data-id="element-106">POS</option>
          <option data-id="element-107">SoftPOS</option>
          <option data-id="element-108">Mobile POS</option>
          <option data-id="element-109">E-Commerce</option>
          <option data-id="element-110">RAAST QR</option>
          <option data-id="element-111">RAAST RTP</option>
        </select>

        <select value={scheme} onChange={e => handleSelectChange('scheme', e.target.value)} className="text-sm border border-slate-200 rounded-xl py-2 pl-3 pr-8 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 bg-white text-slate-700 hover:bg-slate-50 transition-colors cursor-pointer" data-id="element-112">
          <option data-id="element-113">All Schemes</option>
          <option data-id="element-114">Visa</option>
          <option data-id="element-115">MasterCard</option>
          <option data-id="element-116">UnionPay</option>
          <option data-id="element-117">PayPak</option>
          <option data-id="element-118">RAAST</option>
        </select>

        <select value={branch} onChange={e => handleSelectChange('branch', e.target.value)} className="text-sm border border-slate-200 rounded-xl py-2 pl-3 pr-8 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 bg-white text-slate-700 hover:bg-slate-50 transition-colors cursor-pointer hidden sm:block" data-id="element-119">
          <option data-id="element-120">All Branches</option>
          <option data-id="element-121">Main Branch Karachi</option>
          <option data-id="element-122">DHA Outlet</option>
          <option data-id="element-123">Clifton Branch</option>
        </select>

        <div className="h-6 w-px bg-slate-200 mx-1 hidden lg:block" data-id="element-124"></div>

        <button onClick={onRefresh} className="ml-auto lg:ml-0 p-2 text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-xl transition-colors border border-transparent hover:border-indigo-100" title="Refresh Data" data-id="element-125">
          <RefreshCwIcon className="h-5 w-5" data-id="element-126" />
        </button>
      </div>
    </div>;
};
export default DashboardFilters;